export default {
  setPage: (state, page) => {
    state.title = page.title
    state.subtitle = page.subtitle
  },
}
